import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCalendar } from 'react-icons/fi';
import { BlogListItem } from '../../types';
import { getMediaUrl } from '../../services/blogApi';
import { blogTagUrl } from './blogTagUrl';

interface BlogCardProps {
  blog: BlogListItem;
}

const BlogCard: React.FC<BlogCardProps> = ({ blog }) => {
  const publishedDate = blog.published_at
    ? new Date(blog.published_at).toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })
    : null;

  return (
    <article className="group bg-white dark:bg-slate-800 rounded-2xl border border-gray-200 dark:border-gray-700 overflow-hidden hover:shadow-xl transition-all duration-300">
      {blog.feature_image_url && (
        <Link to={`/blog/${blog.slug}`}>
          <img
            src={getMediaUrl(blog.feature_image_url)}
            alt={blog.feature_image_alt || blog.title}
            className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </Link>
      )}

      <div className="p-6">
        <div className="flex flex-wrap gap-2 mb-3">
          {blog.tags.slice(0, 3).map((tag) => (
            <Link
              key={tag}
              to={blogTagUrl(tag)}
              className="px-2 py-1 text-xs font-semibold rounded-full bg-blue-50 dark:bg-blue-900/20 text-blue-600 dark:text-blue-400 hover:bg-blue-100 dark:hover:bg-blue-900/40 transition-colors"
            >
              {tag}
            </Link>
          ))}
        </div>

        <Link to={`/blog/${blog.slug}`}>
          <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-3 group-hover:text-blue-600 dark:group-hover:text-blue-400 transition-colors">
            {blog.title}
          </h2>
        </Link>

        <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed mb-4 line-clamp-3">
          {blog.excerpt}
        </p>

        {publishedDate && (
          <div className="flex items-center gap-2 text-xs text-gray-400 mb-4">
            <FiCalendar />
            {publishedDate}
          </div>
        )}

        <Link
          to={`/blog/${blog.slug}`}
          className="inline-flex items-center gap-2 text-blue-600 dark:text-blue-400 font-semibold text-sm"
        >
          Read more <FiArrowRight />
        </Link>
      </div>
    </article>
  );
};

export default BlogCard;
